import { LinkProps as NextLinkProps } from "next/link";

// Copied from: https://github.com/vercel/next.js/blob/df0e61b023a0fd75b57fbd184be67e42048b991e/packages/next/shared/lib/utils.ts#L311
// Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
// Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3
const ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;

export const isAbsoluteUrl = (url: string) => ABSOLUTE_URL_REGEX.test(url);

const HOSTNAME_TO_SITE: Record<string, "swdc" | "try" | "support"> = {
  "solarwinds.com": "swdc",
  "www.solarwinds.com": "swdc",
  "try.solarwinds.com": "try",
  "support.solarwinds.com": "support",
};

const getSiteForHostname = (hostname: string): string | null =>
  HOSTNAME_TO_SITE[hostname] ?? null;

export const isInternalUrl = (href: NextLinkProps["href"]): boolean => {
  if (typeof href === "object" || !isAbsoluteUrl(href)) {
    return true;
  }

  try {
    const { hostname } = new URL(href);

    return hostname.split(".").some((label) => label === "solarwinds");
  } catch {
    return false;
  }
};

/**
 * On non-production environments (preview, local), converts an absolute URL that points to
 * the current site into a relative path.
 * Production is detected via NEXT_PUBLIC_ENVIRONMENT === "production" and is skipped.
 * Already relative URLs are returned unchanged.
 */
export const replaceAbsoluteUrlWithRelative = (href: string): string => {
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === "production") return href;
  if (!isAbsoluteUrl(href)) return href;

  const site = process.env.SITE;
  if (!site) return href;

  try {
    const hrefUrl = new URL(href);

    if (getSiteForHostname(hrefUrl.hostname) !== site) {
      return href;
    }

    const normalizedPathname = `/${hrefUrl.pathname.replace(/^\/+/, "")}`;

    return `${normalizedPathname}${hrefUrl.search}${hrefUrl.hash}`;
  } catch {
    // keep original href unchanged
  }

  return href;
};
